export enum EmailMarketingSourceDTO {
    EMAIL_OCTOPUS = 'EMAIL_OCTOPUS',
    MAILCHIMP = 'MAILCHIMP'
}
